import { FeatureAppConfig } from '@ngw6fa/feature-app';
import { ModelOverviewIntegratorOptions } from './create-options-from-query-params';
import { digitalBadgeData } from './mocks/consumer-reports-config';

export const graphQLServerUrl = 'http://localhost:8080/graphql';
export const youtubePlayerConfig = {
  videoId: '8JedJtddDmo',
  videoMaxWidth: '100%',
  settings: {
    playerVars: {
      autoplay: 0,
    },
  },
};

export function createMofaConfig({
  mode,
  faServicesUrl,
}: ModelOverviewIntegratorOptions): FeatureAppConfig & any {
  return {
    mode,
    scrollTopOffset: 24, // static padding of the container in integrator.tsx,
    digitalBadgeData, // Consumer Reports Data from mocks,
    // FORMS FEATURE APP
    formConfiguration: {
      featureAppSize: 'grid000',
      successMessageContent: {
        headerLabel: 'Thank you for contacting us from Integrator!',
        description:
          '<p>We have received your message. <br /> <br /> Our team will contact you as soon as possible to give you the information you need. FROM INTEGRATOR</p>',
        buttonCtaLabel: 'Okay from Integrator',
      },
      failedMessageContent: {
        headerLabel: 'Ops Integrator!',
        description: '<p>Ops message from Integrator</p>',
        buttonCtaLabel: 'Back $$formName$$ from Integrator',
      },
    },
    faServicesUrl,
    youtubePlayerConfig,
    graphQLServerUrl,
  };
}
